import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";

export default function GlobalStatusBanner() {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const handleServerError = (event) => {
      const detail = event?.detail || {};
      setNotice({
        type: "server",
        text: "A apărut o eroare pe server. Administratorii au fost notificați.",
        code: detail.status ? `HTTP ${detail.status}` : "",
      });
    };
    const handleClientError = () => {
      setNotice({
        type: "client",
        text: "A apărut o eroare de afișare. Reîncarcă pagina.",
        code: "",
      });
    };
    window.addEventListener("mb:server-error", handleServerError);
    window.addEventListener("mb:client-error", handleClientError);
    return () => {
      window.removeEventListener("mb:server-error", handleServerError);
      window.removeEventListener("mb:client-error", handleClientError);
    };
  }, []);

  if (!notice) return null;

  return (
    <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${notice.type === "server" ? "mt-4" : "mt-4"}`}>
      <div className="flex items-start gap-3 rounded-sm border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-sm">
        <AlertTriangle className="mt-0.5 shrink-0" size={16} />
        <div className="min-w-0 flex-1">
          <div className="font-medium">{notice.text}</div>
          {notice.code && <div className="mt-0.5 text-xs text-amber-800">{notice.code}</div>}
        </div>
        <button
          type="button"
          className="shrink-0 rounded-sm p-1 text-amber-700 hover:bg-amber-100"
          onClick={() => setNotice(null)}
          aria-label="Închide notificarea"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
